import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowRight } from 'lucide-react';
import { blogPosts } from '../blogData';

const BlogPage = () => {
  return (
    <>
      <Helmet>
        <title>Blog | Naru Tofu - Tofu Recipes, Nutrition & Vegan Living</title>
        <meta name="description" content="Read the latest articles about tofu nutrition, vegan recipes, plant-based living in Bangalore, and healthy eating tips from Naru Tofu." />
        <link rel="canonical" href="https://narutofu.com/blog" />
      </Helmet>
      <section className="section-padding" style={{ minHeight: '100vh' }}>
        <div className="container">
          <h1 className="hero-large" style={{ textAlign: 'center', marginBottom: '24px' }}>
            Blog
          </h1>
          <p className="body-large" style={{ textAlign: 'center', marginBottom: '60px', maxWidth: '800px', margin: '0 auto 60px', color: 'var(--text-secondary)' }}>
            Insights on plant-based living, tofu recipes, and healthy eating in Bangalore.
          </p>
          
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            {blogPosts.map((post) => (
              <Link 
                key={post.id} 
                to={`/blog/${post.slug}`}
                style={{ textDecoration: 'none' }}
                data-testid={`blog-card-${post.slug}`}
              >
                <article className="hover-lift" style={{ 
                  background: 'var(--bg-secondary)', 
                  marginBottom: '32px',
                  border: '1px solid var(--border-light)',
                  overflow: 'hidden',
                  transition: 'transform 0.2s ease'
                }}>
                  {post.image && (
                    <div style={{ width: '100%', height: '320px', overflow: 'hidden' }}>
                      <img 
                        src={post.image} 
                        alt={post.title}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        loading="lazy"
                      />
                    </div>
                  )}
                  <div style={{ padding: '32px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px', flexWrap: 'wrap' }}>
                      {post.tags && post.tags.map((tag, i) => (
                        <span key={i} style={{ 
                          fontSize: '12px', 
                          fontWeight: '600',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          color: 'var(--text-primary)',
                          background: 'var(--bg-primary)',
                          padding: '4px 10px',
                          border: '1px solid var(--border-light)'
                        }} data-testid={`blog-tag-${tag.replace(/\s+/g, '-').toLowerCase()}`}>
                          {tag}
                        </span>
                      ))}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '12px' }}>
                      <span className="body-small" style={{ color: 'var(--text-secondary)' }}>{post.date}</span>
                      <span className="body-small" style={{ color: 'var(--text-secondary)' }}>by {post.author}</span>
                    </div>
                    
                    <h2 className="heading-1" style={{ marginBottom: '12px', color: 'var(--text-primary)' }}>{post.title}</h2>
                    <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '20px', lineHeight: '1.7' }}>
                      {post.excerpt}
                    </p>
                    
                    <div className="btn-icon" data-testid={`blog-read-more-${post.slug}`}>
                      Read more
                      <ArrowRight size={16} />
                    </div>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogPage;
